export const isAuthenticated = () => {
  const token = localStorage.getItem('token');
  return Boolean(token) && token !== 'undefined' && token !== 'null';
};
